export default "__VITE_ASSET__C1GtpWra__"